export default __webpack_public_path__ + "static/media/party-molly.b3f8692b.jpg";